import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  navItemWrapper: {
    padding: 0,
  },
  navItem: {
    margin: 0,
    color: colors.white,
    padding: "12px 12px 12px 32px",
  },
  text: ({ isSelected }: { isSelected: boolean }) => ({
    fontWeight: isSelected ? 600 : 400,
    color: colors.white,
  }),
}));

export default useStyles;
